<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import { Routes } from '@/const/Routes'
  import { useAppRouting } from '@/composables/useAppRouting'

  import Typography from '@/components/common/Typography.vue'
  import VgsButton from '@/components/common/VgsButton.vue'
  import RichTextRenderer from '@/components/common/RichTextRenderer.vue'
  import type { AnchorNavigationPage } from '@/types/AnchorNavigationPage'

  const { t } = useI18n()

  const { getRouteWithParams } = useAppRouting()

  const { subjectResourceCategory, subjectResourceTitle, subjectResourceIntroduction } = defineProps<{
    isTeacher: boolean | null,
    subjectResourceCategory: string
    subjectResourceTitle: string
    subjectResourceIntroduction: string,
    resourceGuide: AnchorNavigationPage | null
  }>()
  </script>

<template>
  <div class="top">
    <typography variant="label" data-testid="category">
      {{ subjectResourceCategory }}
    </typography>

    <typography variant="h1" data-testid="title">
      {{ subjectResourceTitle }}
    </typography>

    <div
      v-if="subjectResourceIntroduction"
      class="introduction"
      data-testid="introduction"
    >
      <RichTextRenderer :rich-text="subjectResourceIntroduction" />
    </div>
    
    <router-link
      v-if="isTeacher && resourceGuide"
      :to="getRouteWithParams(Routes.ResourceGuide, resourceGuide)"
      class="link"
    >
      <VgsButton
        type="label"
        variant="quaternary"
        shape="rounded"
        size="large"
        icon-left="info-circle"
        data-testid="resource-guide"
      >
        {{ t('subject.to-teacher') }}
      </VgsButton>
    </router-link>
  </div>
</template>

<style scoped lang="scss">
  .top {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 40px 0;
    max-width: $vgs-max-width-content;
  }

  .introduction {
    margin-bottom: 16px;

    :deep(.cms-p) {
      @include preamble;
    }
  }
  </style>